import {useAlert} from "@contexts/hooks/useAlert.ts";
import {_OrcamentosEndpoints} from "@localization/siteMap/endpoints/_OrcamentosEndpoints.ts";
import type {IFormaPagamento} from "@models/formaPagamento/IFormaPagamento.ts";
import {AddOutlined, RemoveOutlined} from "@mui/icons-material";
import {Button, FormControlLabel, Grid, IconButton, Switch, TextField} from "@mui/material";
import React from "react";

import {useApi} from "@contexts/hooks/api/useApi.ts";
import {DefaultContainer} from "@shared/DefaultContainer.tsx";

export const CriaFormaPagamentoComponent = () => {
    const {createAlertFromResponse} = useAlert()
    const {Get} = useApi()

    const [formaPagamento, setFormaPagamento] = React.useState<IFormaPagamento>({
        id: 0,
        isAtivo: true,
        nome: '',
        isAntecipacao: false,
        orcamentos: [],
        forms: []
    });

    const addNewFormHandler = () => {
        setFormaPagamento({
            ...formaPagamento,
            forms: [...formaPagamento.forms, {id: 0, formaPagamentoId: 0, nome: '', descricao: '', entries: []}]
        })
    }

    const removeFormHandler = (index: number) => {
        setFormaPagamento({
            ...formaPagamento,
            forms: formaPagamento.forms.filter((_, i) => i !== index)
        })
    }

    const sendHandler = () => {
        const forms = formaPagamento.forms.filter(x => x.nome != null).map((form) => ({
            ...form,
            formaPagamentoId: formaPagamento.id
        }))

        Get(_OrcamentosEndpoints.CreateFormaPagamento({data: {...formaPagamento, forms}})).then(x => {
            createAlertFromResponse(x)
            if (x.status == 'Success') {
                setFormaPagamento({
                    id: 0,
                    nome: '',
                    isAtivo: true,
                    descricao: undefined,
                    isAntecipacao: false,
                    orcamentos: [],
                    forms: []
                })
            }
        })
    }

    return (
        <DefaultContainer permissaoNecessaria={['CriarFormaPagamento']}>
            <Grid size={12} mb={1} justifyContent={'space-between'} container>
                <Grid/>
                <Grid size={6}>
                    <Button fullWidth sx={{height: '100%'}}
                            onClick={sendHandler}
                    >Criar</Button>
                </Grid>
            </Grid>
            <Grid container>
                <Grid size={{xs: 12, sm: 6}}>
                    <TextField fullWidth label={'Nome'} value={formaPagamento.nome} onChange={(e) => {
                        setFormaPagamento({
                            ...formaPagamento,
                            nome: e.target.value
                        })
                    }}/>
                </Grid>
                <Grid size={{xs: 12, sm: 6}}>
                    <TextField fullWidth label={'Descrição'} value={formaPagamento.descricao ?? ''} onChange={(e) => {
                        setFormaPagamento({
                            ...formaPagamento,
                            descricao: e.target.value
                        })
                    }}/>
                </Grid>
                <Grid size={12} container justifyContent={'space-between'}>
                    <Grid/>
                    <Grid>
                        <FormControlLabel value={formaPagamento.isAntecipacao} onChange={(_e, v) => {
                            setFormaPagamento({
                                ...formaPagamento,
                                isAntecipacao: v
                            })
                        }} control={<Switch/>} label={'Pagamento antecipado'}/>
                    </Grid>
                </Grid>
            </Grid>
            <Grid size={12}>
                <Grid container justifyContent={'space-between'}>
                    <Grid/>
                    <Grid size={1}>
                        <IconButton onClick={addNewFormHandler} sx={{borderRadius: 0, height: '100%', width: '100%'}}>
                            <AddOutlined/>
                        </IconButton>
                    </Grid>
                </Grid>
            </Grid>
            <Grid size={12}>
                {formaPagamento.forms.map((form, i) => (
                    <Grid key={form.id} container>
                        <Grid size={4}>
                            <TextField fullWidth label={`Form ${i + 1}`} value={form.nome} onChange={(e) => {
                                const newForms = [...formaPagamento.forms];
                                newForms[i].nome = e.target.value;
                                setFormaPagamento({
                                    ...formaPagamento,
                                    forms: newForms
                                })
                            }}/>
                        </Grid>
                        <Grid size={7}>
                            <TextField fullWidth label={`Descrição ${i + 1}`} value={form.descricao} onChange={(e) => {
                                const newForms = [...formaPagamento.forms];
                                newForms[i].descricao = e.target.value;
                                setFormaPagamento({
                                    ...formaPagamento,
                                    forms: newForms
                                })
                            }}/>
                        </Grid>
                        <Grid size={1}>
                            <IconButton sx={{borderRadius: 0, height: '100%', width: '100%'}}
                                        onClick={() => removeFormHandler(i)}>
                                <RemoveOutlined color={'error'} fontSize={'large'}/>
                            </IconButton>
                        </Grid>
                    </Grid>
                ))}
            </Grid>
        </DefaultContainer>
    )
}